<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择条码"
      class="customer-edit"
      width="1200px"
      top="5vh">
    <vm-table ref="vmTable" :filter.sync="filter" module="basic" url="snRule">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="规则编号：">
            <el-input v-model.trim="filter.snRuleNo" placeholder="请输入规则编号"/>
          </vm-search>
          <vm-search label="规则样式：">
            <el-input v-model.trim="filter.snRuleExpression" placeholder="请输入规则样式"/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="snRuleNo" align="center" label="规则编号" width="100"/>
      <el-table-column prop="snType" align="center" width="100" label="规则类型">
        <template slot-scope="scope">
          <span v-if="scope.row.snType === 10">产品条码</span>
          <span v-else>外箱条码</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="snRuleExpression"
          align="left"
          width="200"
          label="规则样式"
          show-overflow-tooltip/>
      <el-table-column prop="snRuleExpressionDesc" align="left" show-overflow-tooltip label="规则描述"/>
      <el-table-column prop="snLength" align="center" label="字符总数" width="80"/>
      <el-table-column
          prop="snRuleDesc"
          align="left"
          label="备注"
          width="150"
          show-overflow-tooltip/>
      <el-table-column prop="status" align="center" label="状态" width="90">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 10">待确认</span>
          <span v-else-if="scope.row.status === 20">已确认</span>
          <span v-else>已作废</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="80px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "BarCodeRulesSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        snTypes: [],
        dialogVisible: false,
        filter: {
          snRuleNo: "",
          snRuleExpression: "",
        },
      };
    },
    methods: {
      // 获取规则类型
      getRuleType() {
        this.$http.get("basic", "dictionaries/dictEnum/SnType").then((resp) => {
          if (resp.success) {
            this.snTypes = resp.data;
          }
        });
      },

      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
          this.getRuleType();
        });
      },

      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
